import { Component, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { OverlayHelper } from '../../../../helper/overlay.helper';
import { CONTACTS_DATA_SERVICE, ContactsDataService } from '../../../../services/contacts/contacts-data.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseCustomDialog } from '../../../shared-module/dialogs/base-custom-dialog';

@Component({
  selector: 'fi-delete-confirm',
  templateUrl: './delete-confirm.component.html',
  styleUrls: ['./delete-confirm.component.scss'],
  standalone: false,
})
export class DeleteConfirmComponent extends BaseCustomDialog implements OnDestroy {
  @Output() popupClosed = new EventEmitter<boolean>();
  messageSnippet = 'REQUEST_DETAIL_LEAD_HISTORY_NOTE_DELETE';
  confirmSnippet = 'REQUEST_DETAIL_LEAD_HISTORY_NOTE_DELETE_CONFIRM';
  cancelSnippet = 'REQUEST_DETAIL_LEAD_HISTORY_NOTE_DELETE_CANCEL';
  replaceKeys = false;
  hasCancel = true;
  customDescriptionSnippet = '';
  descriptionParams: { [key: string]: any };

  constructor(
    public dialogRef: MatDialogRef<DeleteConfirmComponent>,
    @Inject(CONTACTS_DATA_SERVICE) private contactsDataService: ContactsDataService,
    @Inject(MAT_DIALOG_DATA) public dialogData: {
      customMessageSnippet?: string,
      customConfirmSnippet?: string,
      customCancelSnippet?: string,
      replaceKeys?: boolean,
      hasCancel?: boolean,
      customDescriptionSnippet?: string,
      customDescriptionParams?: { [key: string]: any },
      customConfirmValue?: string,
      customCancelValue?: string,
    },
  ) {
    super(dialogRef);
    if ( dialogData?.customMessageSnippet ) {
      this.messageSnippet = dialogData.customMessageSnippet;
    }

    if ( dialogData?.customConfirmSnippet ) {
      this.confirmSnippet = dialogData.customConfirmSnippet;
    }

    if ( dialogData?.customCancelSnippet ) {
      this.cancelSnippet = dialogData.customCancelSnippet;
    }

    if ( dialogData?.customDescriptionSnippet ) {
      this.customDescriptionSnippet = dialogData.customDescriptionSnippet;
    }

    if ( dialogData?.customDescriptionParams ) {
      this.descriptionParams = dialogData.customDescriptionParams;
    }

    if ( typeof dialogData?.replaceKeys === 'boolean' ) {
      this.replaceKeys = dialogData?.replaceKeys;
    }

    if ( typeof dialogData?.hasCancel === 'boolean' ) {
      this.hasCancel = dialogData?.hasCancel;
    }
  }

  ngOnDestroy(): void {
    OverlayHelper.unfixBody();
  }

  closeDialog( confirm: boolean = false ): void {
    this.popupClosed.emit(true);
    this.clearClassAndCloseDialog(this.dialogRef);
    this.dialogRef.close(confirm);
  }


  cancel(): void {
    this.clearClassAndCloseDialog(this.dialogRef, this.dialogData?.customCancelValue ?? false);
  }

  confirm(): void {
    this.clearClassAndCloseDialog(this.dialogRef, this.dialogData?.customConfirmValue ?? true);
  }

  onClosePopup( confirm: boolean = false ): void {
    this.closeDialog(confirm);
  }

  onOverlayClick( event: Event ): void {

    if ( event.target === event.currentTarget ) {
      this.onClosePopup();
    }
  }
}
